export var EnvironmentType;
(function (EnvironmentType) {
    EnvironmentType["Formation"] = "formation";
    EnvironmentType["Internal"] = "internal";
    EnvironmentType["Preproduction"] = "preproduction";
    EnvironmentType["Production"] = "production";
    EnvironmentType["Test"] = "test";
})(EnvironmentType || (EnvironmentType = {}));
//# sourceMappingURL=types.js.map